import TruckingReports from "./TruckingReports";
export default function TruckingReconciliation() { return <TruckingReports reconciliation />; }
